import gql from "graphql-tag";
import API from "./client";
import { SubscribeEmail } from "@/graphql/SubscribeEmail";

export function CreateEmailSubscription(payload) {
  return API.mutate({
    mutation: gql`
      ${SubscribeEmail()}
    `,
    variables: {
      data: {
        email: payload?.email,
      },
      status: "PUBLISHED",
    },
  });
}
